import React, {
    createContext,
    useState,
    useContext,
    ReactNode,
    useEffect,
} from "react";
import { callErrorToast } from "../../../utilities/index.js";
import { CompaniesService } from "../../../services/registry/companies.ts";
import { Company } from "../../../Models/Company.ts";
import { ErrorResponse } from "../../../Models/Error.ts";

const companiesService = new CompaniesService();

interface DeleteCompanyProviderProps {
    children: ReactNode;
    data?: string[];
    callback?: () => void;
}

interface DeleteCompanyContextValue {
    loader: boolean;
    deleteCompanies: () => void;
    data: string[];
    callback?: () => void;
}

const DeleteCompanyContext = createContext<
    DeleteCompanyContextValue | undefined
>(undefined);

const DeleteCompanyProvider: React.FC<DeleteCompanyProviderProps> = ({
    children,
    data = [],
    callback,
}) => {
    const [error, setError] = useState<ErrorResponse<Company> | null>(null);
    const [loader, setLoader] = useState<boolean>(false);

    const deleteCompanies = (): void => {
        setLoader(true);
        const promises = data.map((id) => companiesService.delete(id));
        Promise.all(promises)
            .then((res) => {
                console.log(res);
                setLoader(false);
                if (callback) {
                    callback();
                }
            })
            .catch((err) => {
                setLoader(false);
                setError(err);
            });
    };

    useEffect(() => {
        if (error) {
            callErrorToast(error);
        }
    }, [error]);

    return (
        <DeleteCompanyContext.Provider
            value={{ loader, deleteCompanies, data, callback }}
        >
            {children}
        </DeleteCompanyContext.Provider>
    );
};

const useDeleteCompanyContext = (): DeleteCompanyContextValue => {
    const context = useContext(DeleteCompanyContext);
    if (!context) {
        throw new Error(
            "useDeleteCustomerContext must be used within a DeleteCustomerProvider"
        );
    }
    return context;
};

export { DeleteCompanyProvider, useDeleteCompanyContext };
